import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '@/store/authStore';
import { ROUTES } from '@/utils/constants';

const PrivateRoute = () => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Outlet /> : <Navigate to={ROUTES.LOGIN} replace />;
};

export default PrivateRoute;
